__turbopack_context__.v({
  "muteIcon": "uAwisa_muteIcon",
  "muteText": "uAwisa_muteText",
  "unmuteButton": "uAwisa_unmuteButton",
});
